// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1YS9j","buttons":"RemoveExpirationActionButtons_buttons__1Io8V"};